import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

// ShieldPayments PDF Export - Simple version

const formatCurrency = (amount) => `Rs. ${(amount || 0).toLocaleString('en-IN')}`;

export const exportDailyReport = (reportData, language = 'en') => {
    try {
        console.log('Creating PDF document...');
        const doc = new jsPDF();
        
        // Header
        doc.setFillColor(59, 130, 246);
        doc.rect(0, 0, 210, 30, 'F');
        
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(20);
        doc.setFont('helvetica', 'bold');
        doc.text('ShieldPayments', 15, 15);
        
        doc.setFontSize(12);
        doc.setFont('helvetica', 'normal');
        doc.text('Daily Report', 15, 23);
        
        // Date
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(11);
        doc.text(`Date: ${new Date().toLocaleDateString('en-IN')}`, 15, 40);
        
        // Summary
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text('Summary', 15, 55);
        
        doc.setFontSize(11);
        doc.setFont('helvetica', 'normal');
        doc.text(`Total Sales: ${formatCurrency(reportData?.total_sales)}`, 15, 65);
        doc.text(`Total Expenses: ${formatCurrency(reportData?.total_expenses)}`, 15, 73);
        doc.text(`Net Profit: ${formatCurrency(reportData?.profit)}`, 15, 81);
        doc.text(`Transactions: ${reportData?.transaction_count || 0}`, 15, 89);
        
        // Transactions table if available
        if (reportData?.transactions && reportData.transactions.length > 0) {
            doc.setFontSize(14);
            doc.setFont('helvetica', 'bold');
            doc.text('Transactions', 15, 105);
            
            autoTable(doc, {
                startY: 110,
                head: [['Time', 'Type', 'Category', 'Amount']],
                body: reportData.transactions.slice(0, 15).map(tx => [
                    new Date(tx.created_at).toLocaleTimeString('en-IN', {hour: '2-digit', minute: '2-digit'}),
                    tx.type === 'sale' ? 'Sale' : 'Expense',
                    tx.category || '-',
                    formatCurrency(tx.amount)
                ]),
                theme: 'striped',
                headStyles: { fillColor: [59, 130, 246] }
            });
        }
        
        // Footer
        const pageHeight = doc.internal.pageSize.getHeight();
        doc.setFontSize(8);
        doc.setTextColor(128, 128, 128);
        doc.text('Generated by ShieldPayments', 105, pageHeight - 10, { align: 'center' });
        
        // Save
        const fileName = `ShieldPayments_Daily_${new Date().toISOString().split('T')[0]}.pdf`;
        console.log('Saving PDF:', fileName);
        doc.save(fileName);
        
        return fileName;
    } catch (error) {
        console.error('PDF generation error:', error);
        throw error;
    }
};

export const exportMonthlyReport = (reportData, language = 'en') => {
    try {
        console.log('Creating Monthly PDF...');
        const doc = new jsPDF();
        
        // Header
        doc.setFillColor(59, 130, 246);
        doc.rect(0, 0, 210, 30, 'F');
        
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(20);
        doc.setFont('helvetica', 'bold');
        doc.text('ShieldPayments', 15, 15);
        
        doc.setFontSize(12);
        doc.setFont('helvetica', 'normal');
        doc.text('Monthly P&L Report', 15, 23);
        
        // Period
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(11);
        doc.text(`Period: ${reportData?.month || new Date().toLocaleDateString('en-US', {month: 'long', year: 'numeric'})}`, 15, 40);
        
        // P&L Summary
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text('Profit & Loss Summary', 15, 55);
        
        autoTable(doc, {
            startY: 60,
            body: [
                ['Total Revenue (Sales)', formatCurrency(reportData?.total_sales)],
                ['Total Expenses', formatCurrency(reportData?.total_expenses)],
                ['Gross Profit/Loss', formatCurrency(reportData?.profit)]
            ],
            theme: 'plain',
            styles: { fontSize: 12 },
            columnStyles: {
                0: { fontStyle: 'bold', cellWidth: 100 },
                1: { halign: 'right' }
            }
        });
        
        // Daily breakdown if available
        if (reportData?.daily_data && reportData.daily_data.length > 0) {
            const startY = doc.lastAutoTable.finalY + 15;
            
            doc.setFontSize(14);
            doc.setFont('helvetica', 'bold');
            doc.text('Daily Breakdown', 15, startY);
            
            autoTable(doc, {
                startY: startY + 5,
                head: [['Date', 'Sales', 'Expenses', 'Profit']],
                body: reportData.daily_data.slice(0, 20).map(day => [
                    day.date,
                    formatCurrency(day.sales),
                    formatCurrency(day.expenses),
                    formatCurrency((day.sales || 0) - (day.expenses || 0))
                ]),
                theme: 'striped',
                headStyles: { fillColor: [59, 130, 246] }
            });
        }
        
        // Footer
        const pageHeight = doc.internal.pageSize.getHeight();
        doc.setFontSize(8);
        doc.setTextColor(128, 128, 128);
        doc.text('Generated by ShieldPayments', 105, pageHeight - 10, { align: 'center' });
        
        // Save
        const fileName = `ShieldPayments_Monthly_${new Date().toISOString().slice(0, 7)}.pdf`;
        console.log('Saving Monthly PDF:', fileName);
        doc.save(fileName);
        
        return fileName;
    } catch (error) {
        console.error('Monthly PDF error:', error);
        throw error;
    }
};

export default { exportDailyReport, exportMonthlyReport };
